import MaterialPropertyAssigner from "./material-property-assigner.js";

class MaterialPropertySplitAssigner extends MaterialPropertyAssigner {
    constructor(propertyTypes) {
        super();

        this._propertyTypes = {};
        this._assigners = {};

        for (const type in propertyTypes) {
            const { properties, assigner } = propertyTypes[type];

            for (const prop of properties) {
                this._propertyTypes[prop] = type;
            }

            this._assigners[type] = assigner;
        }
    }

    setProperty(material, property, value) {
        const type = this._propertyTypes[property];
        const assigner = this._assigners[type];
        assigner.setProperty(material, property, value);
    }
}

export default MaterialPropertySplitAssigner;
